<template>
	<div class="topUps">
		<div class="topUps_head">
			<span class="ups_left">充值确认</span>
			<span class="ups_right" @click="close()">关闭</span>
		</div>


		<div class="wrapMoney">
		  <div class="price">￥{{money}}</div>
		  <div class="dianchi">充值{{money*100}}电池</div>
		  <div class="time">{{mytime}}</div>
		<div class="clear"></div>
		<div class="radioSelect">
			<h1>支付方式</h1>
			  <el-radio-group v-model="radio">
					<el-radio :label="item.id" border  v-for="item in payinfoData.payWays" :key="item">
						{{item.way_title}}
					</el-radio>	
			  </el-radio-group>			
		</div>	
		  <span class="btn">
		    <el-button type="primary" @click.native="pay()" v-if="loading">确认支付</el-button>
		    <el-button type="primary" :loading="true" v-else>加载中</el-button>
		  </span>
		</div>
		<!--扫码支付-->
		<transition name="el-fade-in">
			<div class="payblock" v-if="showEr">
				<div class="payBox">
					<h1>扫码支付</h1>
				    <img :src="url_er"  id="scream"/>
					<div class="paybtn">
						<div class="btn_left" @click="close()">
							取消
						</div>
						<div class="btn_right" @click="close()">
							确定
						</div>
					</div>
				</div>		
			</div>
		</transition>
	</div>
</template>

<script>
import qs from "qs"	
import QRCode from 'qrcode'
export default {	
	props:['payShowFc','otherPrice'],	
  data () {
    return {
	 		payData:'',
	 		money:this.otherPrice,
	 		time:'',
	 		timer:'',
	 		payinfoData:[],
	 		radio:'',
	 		url_er:'',
	 		showEr:false,
	 		loading:true,
    }
  },
  computed:{
    mytime:function(){
        return this.time;
    }
  },  
  methods:{
	close(){
  		if (this.payShowFc) {
          this.payShowFc();
        }
	},
  	getInfo(){	 	
		//创建订单	
  		let params = qs.stringify({
					recharge_amt:this.money*100
			})  		
		this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
			this.$axios.post('/goods/account/v1/account_recharge',params)
			.then(userData=>{
				if(userData.data.resultCode=='0000'){
					this.payData=userData.data.resultInfo
					this.payinfo(this.payData)
				}else{
					this.$message.error(userData.data.resultMsg);
				}	
			}).catch(error=>{
				console.log(error)
			})  		
  	},
	//查询支付方式
  	payinfo(data){	

  		let params = qs.stringify({
					payData:JSON.stringify(data),
					way_code:"NATIVE"
			})  		
		this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
			this.$axios.post('/pay/app/v1/getPayInfo',params)
			.then(userData=>{
				if(userData.data.resultCode=='0000'){
					this.payinfoData=userData.data.resultInfo
					this.radio=this.payinfoData.payWays[0].id
				}else{
					this.$message.error(userData.data.resultMsg);
				}	
			}).catch(error=>{
				console.log(error)
			})  		
  	},
	//生成二维码
  	pay(){		
  		this.loading=false
  		let params = qs.stringify({
					payData:this.payinfoData.payData,
					payWay:this.radio
			})  		
		this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
			this.$axios.post('/pay/app/v1/createOrder',params)
			.then(userData=>{
				this.loading=true
				if(userData.data.resultCode=='0000'){
					this.useqrcode(userData.data.resultInfo.payInfo)
				}else{
					this.$message.error(userData.data.resultMsg);
				}	
			}).catch(error=>{
				console.log(error)
			})  		
  	},
  	closedShow(){
  		//关闭支付二维码-返回上一页
  		this.$router.go(-1)
  	},
 	useqrcode(urls){
		var self=this
		QRCode.toDataURL(urls,{height:400,width:400 })
		  .then(url => {
		    self.url_er=url
		    self.showEr=true
		  })
		  .catch(err => {
		    console.error(err)
		  })
    },  	
  	resetTime(timeStamp){
  		var $this=this
      this.timer=null;
      var t=timeStamp;
      var m=0;
      var s=0;
      m=Math.floor(t/60%60);
      m<10&&(m='0'+m);
      s=Math.floor(t%60);
      function countDown(){
          s--;
          s<10&&(s='0'+s);
          if(s.length>=3){
              s=59;
              m="0"+(Number(m)-1);
          }
          if(m.length>=3){
              m='00';
              s='00';
              clearInterval($this.timer);
          }
         $this.time="支付剩余时间"+m+"分"+s+"秒"
          if(m==0 && s==0){
            clearInterval($this.timer);
            $this.close()
            return false
          }
      }
      this.timer=setInterval(countDown,1000);
    },
	getCookie(c_name){
	//判断document.cookie对象里面是否存有cookie
	if (document.cookie.length>0){
	  var c_start=document.cookie.indexOf(c_name + "=")
		//如果document.cookie对象里面有cookie则查找是否有指定的cookie，如果有则返回指定的cookie值，如果没有则返回空字符串
	  if (c_start!=-1){ 
	    c_start=c_start + c_name.length+1 
	   var c_end=document.cookie.indexOf(";",c_start)
	    if (c_end==-1) c_end=document.cookie.length
	    return unescape(document.cookie.substring(c_start,c_end))
	    } 
	  }
	return ""
	}
  },
  created:function(){
  	this.resetTime('300')
  	this.getInfo()
  }
}	
</script>

<style scoped>
.topUps{
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background: #FFFFFF;
	z-index: 10000;
	overflow: auto;
	padding-top: 40px;
}
.topUps_head{
	background: #F2F6FC;
	position: absolute;
	width: 100%;
	left: 0;
	top: 0;
	line-height: 40px;
	padding: 0px 15px;
	overflow: hidden;
}
.ups_left{
	float: left;
	font-weight: bold;
}
.ups_right{
	float: right;
	color: red;
	cursor: pointer;
}


.wrapMoney{

}
.wrapMoney .price{
  padding-top: 50px;
  text-align: center;
  font-weight: bold;
  padding-bottom: 10px;
}
.wrapMoney .dianchi{
  text-align: center;
  color: #6666;
  padding-bottom: 10px;
}
.wrapMoney .time{
  text-align: center;
  color: #6666;
  padding-bottom: 20px;
  height: 40px;
  line-height: 40px;
}
.wrapMoney .pay_mode{
  overflow: hidden;
  background: #ffffff;
  padding: 8px 15px;
  display: block;
}
.wrapMoney .pay_mode img{
  float: left;
  height: 60px;
}
.wrapMoney .pay_mode .name{
  float: left;
  line-height: 50px;
  padding-left: 15px;
  color: #6666;
}
.wrapMoney .pay_mode .radio{
  float: right;
}
.wrapMoney .btn{
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  padding: 30px 15px;
  box-sizing: border-box;
}
.wrapMoney button{
  height: 40px;
  border: none;
  margin:0 ;
  color: #ffffff;
  font-weight: normal;
  width: 100% !important;

}

.payblock{
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.6);
}
.payBox{
	position: absolute;
	width: 300px;
	background: #FFFFFF;
	border-radius: 10px;
	overflow: hidden;
	top: 50%;
	left: 50%;
	margin-left: -150px;
	margin-top: -200px;
}

.payBox h1{
	text-align: center;
	line-height: 50px;
	font-size: 16px;
}
#scream{
	width: 100%;
}
.payBox .paybtn{
	overflow: hidden;
}
.payBox .btn_left{
	float: left;
	width: 50%;
	text-align: center;
	line-height: 45px;
	color: #000;
	cursor: pointer;
}
.payBox .btn_right{
	float: left;
	width: 50%;
	text-align: center;
	line-height: 45px;
	color: #ee0a24;
	cursor: pointer;
}


</style>


// WEBPACK FOOTER //
// src/components/im/topUpsPy.vue